<template>
    <div>
        <v-card>
            <v-card-title>
                <span>Bonus Time Slices</span>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="dialog=true">New</v-btn>
            </v-card-title>
            <v-data-table :headers="headers" :items="timeSlices" :loading="loading">
                <template v-slot:items="props">
                    <td class="text-xs-left">{{ props.item.id }}</td>
                    <td class="text-xs-left">{{ props.item.start_time }}</td>
                    <td class="text-xs-left">{{ props.item.end_time }}</td>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="dialog" width="40%">
            <v-card>
                <v-card-title>
                    <span class="headline">Add New Time Slice</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-form ref="form">
                            <v-layout wrap>
                                <v-flex xs12>
                                    <choose-time v-model="model.start_time" label="Start Time"/>
                                    <choose-time v-model="model.end_time" label="end Time"/>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-btn color="primary" @click="save" :disabled="loading">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";
    import ChooseTime from "@/components/wasilni/input/ChooseTime";
    import socketEventsMixin from "@/mixins/socketEventsMixin";

    export default {
        mixins: [socketEventsMixin],
        name: "Bonus Time Slices",
        title: "Bonus Time Slices",
        components: {ChooseTime, DataTable},
        data() {
            return {
                headers: [
                    {text: 'ID', value: 'id'},
                    {text: 'Start Time', value: 'start_time'},
                    {text: 'End Time', value: 'end_time'},
                ],
                timeSlices: [],
                loading: false,
                search: '',
                dialog: false,
                model: {
                    start_time: null,
                    end_time: null
                }
            };
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                this.loading = true;
                this.axios.get(`bonus/${this.$route.params.id}`)
                    .then(res => this.timeSlices = res.data.data)
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            },
            save() {
                this.loading = true;
                this.model.bonus_id = this.$route.params.id;
                this.axios.post('bonus/time_slice', this.model)
                    .then(() => {
                        this.getData();
                        this.dialog = false;
                        window.getApp.$emit("SHOW_TOAST", 'success');
                    })
                    .catch(err => {
                        console.log(err);
                        window.getApp.$emit("SHOW_TOAST", err.message, "red");
                    })
                    .finally(() => this.loading = false);
            },
            detach(captain_id, name) {
                let c = confirm(`are you sure you want to detach this ${name}?`);
                if (!c) {
                    return
                }
                this.loading = true;
                this.axios.delete(`bonus_package/${this.$route.params.id}/captains/${captain_id}`)
                    .then(() => {
                        this.getData();
                        this.dialog = false;
                        window.getApp.$emit("SHOW_TOAST", 'success');
                    })
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            }
        }
    }
</script>

<style scoped>

</style>
